'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isImage = exports.isImage = function isImage(filename) {

  return (/(png|jpg|jpeg|gif|bmp|tiff)$/i.test(filename)
  );
};

var getFilename = exports.getFilename = function getFilename(url) {

  var match1 = /\/([^\/]+)$/.exec(url);

  return match1 && match1[1] || '';
};

var getExtension = exports.getExtension = function getExtension(filename) {

  var match2 = /\.([a-z]+)$/.exec(filename);

  return match2 && match2[1];
};

var getBackgroundSize = exports.getBackgroundSize = function getBackgroundSize(file, callback) {

  var img = new Image();

  img.onload = function () {

    var backgroundSize = void 0;
    var r = img.naturalWidth / img.naturalHeight;

    if (r <= 1) {
      backgroundSize = '100% auto';
    } else if (r <= 1.35) {
      backgroundSize = '100% 100%';
    } else {
      backgroundSize = 'auto 100%';
    }

    callback(null, backgroundSize);
  };

  if (file) {
    img.src = file.preview || file;
  } else {
    callback();
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/arreeba-form/lib/lib/files.js
// module id = 108
// module chunks = 0